import { inject, Injectable } from "@angular/core";
import { DoctorMatchingService } from "../../../api/services";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import {
  FilterMatchingDoctorDto,
  FilterResponseMatchingDoctorDto,
} from "../../../api/models";
import { LoggedUserService } from "@keus-template/auth";

@Injectable({
  providedIn: "root",
})
export class DoctorMatchingApiService {
  /** The injected instance of the DoctorMatchingService. */
  private readonly _doctorMatchingService: DoctorMatchingService = inject(
    DoctorMatchingService,
  );

  /** The injected instance of the LoggedUserService. */
  private readonly _loggedUserService: LoggedUserService =
    inject(LoggedUserService);

  /**
   * Filter doctors based on the provided filter criteria.
   * @param body - The filter criteria.
   * @returns An observable that emits the filtered doctors.
   */
  public findMatchingDoctor$(
    filterDto: Partial<FilterMatchingDoctorDto>,
  ): Observable<FilterResponseMatchingDoctorDto> {
    const userId = this._loggedUserService.currentUser().id;

    const body: FilterMatchingDoctorDto = {
      tenant: environment.tenant,
      patientId: userId,
      ...filterDto,
    };

    return this._doctorMatchingService.doctorMatchingControllerFindMatchingDoctor(
      { body },
    );
  }
}
